import React from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';

const COLOR_OPTIONS = [
    '#4CAF50', '#2196F3', '#9C27B0', '#FF9800',
    '#E91E63', '#00BCD4', '#F44336', '#607D8B',
];

const CustomColorDots = ({ value, onValueChange, options = COLOR_OPTIONS }) => (
    <View style={styles.row}>
        {options.map((hex) => {
            const selected = value === hex;
            return (
                <Pressable
                    key={hex}
                    onPress={() => onValueChange(hex)}
                    hitSlop={6}
                    accessibilityRole="button"
                    accessibilityState={{ selected }}
                    style={[styles.dot, { backgroundColor: hex }, selected && styles.dotSelected]}
                >
                    {selected && <Text style={styles.check}>✓</Text>}
                </Pressable>
            );
        })}
    </View>
);

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 12,
    },
    dot: {
        width: 28,
        height: 28,
        borderRadius: 14,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 2,
        borderColor: 'transparent',
    },
    dotSelected: {
        borderColor: '#1A2410',
    },
    check: {
        color: '#fff',
        fontSize: 14,
        fontWeight: '700',
        lineHeight: 16,
    },
});

export default CustomColorDots;